import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Group, Text, Alert, Button } from "@mantine/core";
import tinycolor from "tinycolor2";

import FilterList from "../../presentations/filters/FilterList";

import SpaceFilterSettingModel from "../../../../models/SpaceFilterSetting";
import SpaceFilterModel from "../../../../models/SpaceFilter";

import trackMixpanel from "../../../../utils/TrackMixpanel";
import isSpaceThemed from "../../../../utils/IsSpaceThemed";

export default function SpaceFilterList(props) {
  const [parentFilterSettings, setParentFilterSettings] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const colors = useSelector((state) => state.colors);
  const space = useSelector((state) => state.space);
  const space2 = useSelector((state) => state.space2);
  const user = useSelector((state) => state.user);

  const _space = props.useSpace2 ? space2 : space;

  const space_filters = Array.isArray(_space?.space_filters) ? _space.space_filters : [];
  const space_filters_data = parentFilterSettings.map((f) => {
    const selectedFilter = space_filters.find((f2) => f2.id === f.id);
    let _value = selectedFilter?.value || "";
    if (["string", "number"].includes(typeof _value)) {
      _value = String(_value);
    } else if (["select", "multi_select"].includes(f.format) && Array.isArray(selectedFilter?.value)) {
      _value = _value.map((v) => String(v));
    } else if (f.format === "location" && typeof _value === "string") {
      _value = _value.length > 0 ? { formatted: _value } : null;
    }
    return {
      ...f,
      value: _value,
      space_filter_id: selectedFilter?.space_filter_id
    }
  });
  const _parents = Array.isArray(_space?.parents_slugs) ? _space.parents_slugs : [];
  const parentSlug = _parents[_parents.length - 1] || _space?.slug;
  const propertiesCount = parentFilterSettings.length;
  const shouldShowEditProperties = !!_space?.permissions?.can_manage && propertiesCount > 0 && !!props.useSpace2

  useEffect(() => {
    if (!_space?.slug || loaded || props.editable || !user) return;
    setLoaded(true);
    trackMixpanel(user.username, "Space loaded", { space_slug: _space.slug });
  }, [_space, loaded, user]);

  useEffect(() => {
    getSpaceFilterSettings();
  }, []);

  const getSpaceFilterSettings = () => {
    if (!parentSlug) return;
    SpaceFilterSettingModel.onFetch(
      parentSlug,
      (data) => {
        if (Array.isArray(data)) {
          setParentFilterSettings(data);
        }
      },
      (err) => {}
    );
  }

  const onCreateSpaceFilter = (space_filter_setting_id, value) => {
    SpaceFilterModel.onCreate(
      _space.slug,
      {
        space_filter_setting_id,
        value
      },
      (data) => {},
      (error) => {}
    );
  };

  const onUpdateSpaceFilter = (space_filter_setting_id, space_filter_id, value) => {
    SpaceFilterModel.onUpdate(
      _space.slug,
      space_filter_id,
      {
        space_filter_setting_id,
        value
      },
      (data) => {},
      (error) => {}
    );
  };

  const onRemoveSpaceFilter = (space_filter_id) => {
    SpaceFilterModel.onDestroy(
      _space.slug,
      space_filter_id,
      (data) => {},
      (error) => {}
    );
  };

  const onToogleProperties = () => {
    if (typeof props.setIsEditFilters === "function") {
      props.setIsEditFilters();
    }
  };

  return (
    <>
      {shouldShowEditProperties && (
        <Alert
          color="gray"
          radius="md"
          mt={20}
          styles={(theme) => ({
            root: { padding: "2px 10px" },
            light: {
              backgroundColor: !isSpaceThemed(colors)
                ? theme.colors.gray[0]
                : tinycolor(colors.background_color).lighten(3).toString() 
            }
          })}
        >
          <Group spacing={0} position="apart">
            <Text size="sm" weight={600} sx={{ color: isSpaceThemed(colors) ? colors.default_text_color : "#000" }}>
              {propertiesCount} Propert{propertiesCount === 1 ? "y" : "ies"}
            </Text>
            <Button
              variant="outline"
              radius="md"
              size="sm"
              my={5}
              compact
              sx={(theme) => ({
                backgroundColor: "none",
                color: props.editable ? theme.colors.green[5] : isSpaceThemed(colors) ? colors.default_text_color : theme.colors.gray[6],
                border: `1.5px solid ${props.editable ? theme.colors.green[5] : isSpaceThemed(colors) ? colors.default_text_color : theme.colors.gray[6]}`,
                "&:hover": {
                  backgroundColor: props.editable ? theme.colors.green[0] : isSpaceThemed(colors) ? null : theme.colors.gray[1]
                },
              })}
              onClick={onToogleProperties}
            >
              <Text size="xs" px={10} weight={700}>{props.editable ? "Save" : "Edit"}</Text>
            </Button>
          </Group>
        </Alert>
      )}
      <FilterList
        type="page"
        section={shouldShowEditProperties ? "space-modal" : undefined}
        colors={colors}
        data={space_filters_data}
        isEditMode={props.editable}
        onCreateFilter={onCreateSpaceFilter}
        onUpdateFilter={onUpdateSpaceFilter}
        onRemoveFilter={onRemoveSpaceFilter}
      />
    </>
  );
}
